import { useEffect, useRef } from 'react';
import { beforeItems, afterItems } from '../../../mocks/landingData';

export default function BeforeAfterSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-slide-up');
          }
        });
      },
      { threshold: 0.1 }
    );

    const section = sectionRef.current;
    if (section) {
      const elements = section.querySelectorAll('.animate-on-scroll');
      elements.forEach((el) => observer.observe(el));
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative py-20 md:py-28 bg-warm-white">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <div className="animate-on-scroll opacity-0 inline-flex items-center gap-2 px-4 py-2 rounded-full border border-dark-bronze/30 bg-dark-bronze/10 mb-6">
              <i className="ri-arrow-left-right-line text-dark-bronze text-sm" />
              <span className="text-dark-bronze text-sm font-medium">Before & After</span>
            </div>

            <h2 className="animate-on-scroll opacity-0 font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-midnight mb-6">
              From stuck thinking to{' '}
              <span className="gold-gradient-text">transformational action.</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8">
            <div className="animate-on-scroll opacity-0 bg-midnight/5 rounded-2xl p-6 md:p-8 border border-midnight/10">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 rounded-full bg-midnight/10 flex items-center justify-center">
                  <i className="ri-close-circle-line text-taupe-grey text-xl" />
                </div>
                <h3 className="font-heading text-xl font-semibold text-midnight">Before TNT Coach AI</h3>
              </div>
              <ul className="space-y-4">
                {beforeItems.map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <i className="ri-subtract-line text-taupe-grey mt-1 flex-shrink-0" />
                    <p className="text-taupe-grey text-sm leading-relaxed">{item}</p>
                  </li>
                ))}
              </ul>
            </div>

            <div className="animate-on-scroll opacity-0 bg-midnight rounded-2xl p-6 md:p-8 border border-champagne-gold/20">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 rounded-full gold-gradient flex items-center justify-center">
                  <i className="ri-check-double-line text-midnight text-xl" />
                </div>
                <h3 className="font-heading text-xl font-semibold text-warm-white">After TNT Coach AI</h3>
              </div>
              <ul className="space-y-4">
                {afterItems.map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <i className="ri-check-line text-champagne-gold mt-1 flex-shrink-0" />
                    <p className="text-silver-grey text-sm leading-relaxed">{item}</p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}